import supabase from "../../../shared/database/supabase";
import { ServiceOrderLineRepository } from "../../../models/service-order-line/service-order-line.repository";
import { ServiceOrderLine } from "../model/service-order-line";

export interface GetServiceOrderLinesByServiceOrderResponse {
  service_order_lines: ServiceOrderLineRepository[];
}

export const getServiceOrderLinesByServiceOrder = async (serviceOrderIds: string[]) => {
  try {
    const { data, error } = await supabase.functions.invoke<GetServiceOrderLinesByServiceOrderResponse>(
      "get-service-order-lines-by-service-order",
      {
        body: JSON.stringify({
          ids: serviceOrderIds
        })
      }
    );
    if (error) {
      console.error("Error calling get-service-order-lines-by-service-order:", error);
      return { serviceOrderLines: null, error };
    }
    const serviceOrderLines: ServiceOrderLine[] = (data?.service_order_lines ?? []).map((line) => ({
      id: line.id,
      serviceOrderId: line.service_order_id,
      serviceOrderLineType: {
        id: line.service_order_line_type.id,
        name: line.service_order_line_type.name
      },
      nuovautoClaimId: line.nuovauto_claim_id,
      audatexClaimId: line.audatex_claim_id,
      carRentalId: line.car_rental_id,
      car: line.car
        ? {
            id: line.car.id,
            plate: line.car.plate,
            chassisNumber: line.car.chassis_number,
            model: line.car.model,
            brand: line.car.brand,
            color: line.car.color,
            insuranceName: line.car.insurance_name
          }
        : undefined,
      cost: line.cost,
      discount: line.discount,
      workHours: line.work_hours,
      costByWorkHour: line.cost_by_work_hour,
      createdAt: line.created_at ? new Date(line.created_at) : new Date(),
      updatedAt: line.updated_at ? new Date(line.updated_at) : new Date(),
      createdBy: line.created_by,
      finished: line.finished,
      description: line.description,
      billed: line.billed,
      controlled: line.controlled
    }));

    return { serviceOrderLines, error: null };
  } catch (err) {
    console.error("Exception in getServiceOrderLinesByServiceOrder:", err);
    throw err;
  }
};
